'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { CAMPAIGN_VARIANT_TOP_SPACING_IN_FLOW_ONLY } from '../campaignSpacing';
import { TickerComponent } from './TickerComponent';

/** Campaign variant C. Carries the same top margin as B (SH-415). */
export function TickerComponentC(
  props: React.ComponentProps<typeof TickerComponent>,
) {
  return (
    <TickerComponent
      {...props}
      className={classNames(
        props.className,
        CAMPAIGN_VARIANT_TOP_SPACING_IN_FLOW_ONLY,
      )}
    />
  );
}
